export enum ShowAnnouncementType {
  No = 0,
  Yes = 1,
  BetweenDates = 2
}
